/* lystia-review-form.js - <lystia-review-form> (T-E4-12, parity/pdp-forms.md §3; prototype js/pages/pdp.js L.overlay.register('writeReview')).
   Вміст оверлея `write-review` (snippets/review-form.liquid -> snippets/overlay.liquid). Тригер: [data-overlay-open][data-review-handle] (секція pdp-reviews):
   handle запамʼятовується на capture-кліку і обирає чай у списку. Стани form / invalid / sending / error / success.
   ?state=rv-form|rv-invalid|rv-error|rv-success відкриває оверлей (seed-стани прототипу).
   Транспорт: data-endpoint (A-039, бот @lystia_website_bot); порожній endpoint = імітація 1100 мс без запиту (формат бота /api/review).
   Фото в формі немає (A-079, Q-REVPHOTO: бот фото не приймає). */
if (!customElements.get('lystia-review-form')) {
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const SEND_MS = 1100;
  const OVERLAY = 'write-review';
  let lastHandle = '';
  let pendingStage = '';

  /* handle товару з тригера (capture - до делегата оверлея) */
  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-review-handle]');
    if (t) lastHandle = t.getAttribute('data-review-handle') || '';
  }, true);

  class LystiaReviewForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.rating = 0;
      this.failOnce = false;
      this.submitBtn = this.form.querySelector('[data-submit]');
      this.netSlot = this.form.querySelector('[data-net]');
      this.stars = Array.from(this.form.querySelectorAll('.srate__btn'));
      this.select = this.form.elements.product;
      this.consent = this.form.elements.consent;
      this.f = {
        name: this.mk(this.form.elements.name),
        email: this.mk(this.form.elements.email),
        product: this.mk(this.select),
        rating: { box: this.form.querySelector('[data-field="rating"]'), input: this.stars[0], err: this.form.querySelector('#rv-rating-err') },
        text: this.mk(this.form.elements.text),
        consent: { box: this.form.querySelector('[data-field="consent"]'), input: this.consent, err: this.form.querySelector('#rv-consent-err') },
      };

      this.form.addEventListener('submit', this.onSubmit);
      ['name', 'email', 'text'].forEach((k) => this.f[k].input.addEventListener('input', () => this.setError(this.f[k], null)));
      this.select.addEventListener('change', () => this.select.value && this.setError(this.f.product, null));
      this.consent.addEventListener('change', () => this.consent.checked && this.setError(this.f.consent, null));
      this.initStars();

      const handle = lastHandle || this.dataset.defaultHandle || '';
      if (handle && Array.from(this.select.options).some((o) => o.value === handle)) this.select.value = handle;

      const stage = pendingStage;
      pendingStage = '';
      if (stage) this.applyStage(stage);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    mk(input) {
      const box = input.closest('.field');
      return { input, box, err: box.querySelector('.field__error') };
    }

    get reduced() {
      return !!(document.lystia && document.lystia.reducedMotion && document.lystia.reducedMotion());
    }

    tpl(name) {
      const t = this.querySelector('template[data-tpl="' + name + '"]');
      return t ? t.content.cloneNode(true) : document.createDocumentFragment();
    }

    /* ---------- seed-стани ---------- */
    applyStage(stage) {
      const d = this.dataset;
      if (stage === 'success') { this.showSuccess(); return; }
      if (stage === 'error') {
        this.f.name.input.value = d.demoName;
        this.f.email.input.value = d.demoEmail;
        this.f.text.input.value = d.demoText;
        this.consent.checked = true;
        if (!this.select.value && this.select.options.length > 1) this.select.selectedIndex = 1;
        this.failOnce = true;
        this.showNetError(true);
        this.setSubmitLabel(d.labelRetry);
      }
      if (stage === 'invalid') {
        this.f.email.input.value = 'name@example';
        this.f.text.input.value = 'Смачно';
        this.select.value = '';
        this.validate();
      }
    }

    /* ---------- помилки ---------- */
    setError(f, msg) {
      f.box.classList.toggle('is-error', !!msg);
      f.err.textContent = msg || '';
      if (msg) {
        f.input.setAttribute('aria-invalid', 'true');
        f.input.setAttribute('aria-describedby', f.err.id);
      } else {
        f.input.removeAttribute('aria-invalid');
        f.input.removeAttribute('aria-describedby');
      }
    }

    validate() {
      const d = this.dataset;
      const f = this.f;
      this.setError(f.name, f.name.input.value.trim() ? null : d.msgName);
      this.setError(f.email, EMAIL_RE.test(f.email.input.value.trim()) ? null : d.msgEmail);
      this.setError(f.product, this.select.value ? null : d.msgProduct);
      this.setError(f.rating, this.rating ? null : d.msgRating);
      this.setError(f.text, f.text.input.value.trim().length >= 10 ? null : d.msgText);
      this.setError(f.consent, this.consent.checked ? null : d.msgConsent);
      return !Object.values(f).some((x) => x.box.classList.contains('is-error'));
    }

    focusFirst() {
      const el = this.form.querySelector('.is-error input, .is-error textarea, .is-error select, .is-error button');
      if (el) el.focus();
    }

    /* ---------- оцінка ---------- */
    initStars() {
      const row = this.form.querySelector('.srate');
      this.stars.forEach((b, i) => {
        b.addEventListener('click', () => this.setRating(i + 1));
        b.addEventListener('mouseenter', () => this.paint(i + 1));
        b.addEventListener('keydown', (e) => {
          const v = this.rating;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
            e.preventDefault();
            this.setRating(Math.min(5, (v || 0) + 1));
            this.stars[this.rating - 1].focus();
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
            e.preventDefault();
            this.setRating(Math.max(1, (v || 1) - 1));
            this.stars[this.rating - 1].focus();
          }
        });
      });
      row.addEventListener('mouseleave', () => this.paint(this.rating));
    }

    paint(n) {
      this.stars.forEach((b, i) => b.classList.toggle('is-on', i < n));
    }

    setRating(n) {
      this.rating = n;
      this.paint(n);
      this.stars.forEach((b, i) => {
        b.setAttribute('aria-checked', i === n - 1 ? 'true' : 'false');
        b.tabIndex = i === Math.max(0, n - 1) ? 0 : -1;
      });
      const cur = this.stars[n - 1];
      cur.classList.remove('is-pop');
      void cur.offsetWidth;
      cur.classList.add('is-pop');
      this.setError(this.f.rating, null);
    }

    /* ---------- стани ---------- */
    setSubmitLabel(text) {
      const l = this.submitBtn.querySelector('.btn__label');
      if (l) l.textContent = text;
    }

    setLoading(on) {
      const b = this.submitBtn;
      b.classList.toggle('is-loading', on);
      b.disabled = on;
      b.setAttribute('aria-busy', on ? 'true' : 'false');
      const sp = b.querySelector('.spinner');
      if (on) {
        this.setSubmitLabel(this.dataset.labelSending);
        if (!sp) {
          const s = document.createElement('span');
          s.className = 'spinner';
          s.setAttribute('aria-hidden', 'true');
          b.insertBefore(s, b.firstChild);
        }
      } else if (sp) sp.remove();
      if (on) this.dataset.stage = 'sending';
    }

    showNetError(on) {
      this.netSlot.replaceChildren();
      if (on) this.netSlot.appendChild(this.tpl('net'));
      this.dataset.stage = on ? 'error' : 'form';
    }

    onSubmit = (e) => {
      e.preventDefault();
      if (this.submitBtn.classList.contains('is-loading')) return;
      if (!this.validate()) { this.focusFirst(); return; }
      this.netSlot.replaceChildren();
      this.setLoading(true);
      this.send();
    };

    send() {
      const endpoint = this.dataset.endpoint;
      const fail = () => {
        this.setLoading(false);
        this.setSubmitLabel(this.dataset.labelRetry);
        this.showNetError(true);
      };
      if (!endpoint) {
        const bad = this.failOnce || navigator.onLine === false;
        this.failOnce = false;
        this.timer = setTimeout(() => (bad ? fail() : this.showSuccess()), SEND_MS);
        return;
      }
      /* Формат бота (lystia-bot) POST /api/review: name, email, rating (1-5), body, product (handle).
         Фото не передаються (Q-REVPHOTO OPEN; бот приймає їх лише в multipart). */
      const body = {
        name: this.f.name.input.value.trim(),
        email: this.f.email.input.value.trim(),
        rating: this.rating,
        body: this.f.text.input.value.trim(),
        product: this.select.value,
      };
      const map = { name: 'name', email: 'email', body: 'text', product: 'product', rating: 'rating' };
      this.failOnce = false;
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then((r) => r.json().catch(() => ({})).then((j) => ({ ok: r.ok && j.ok !== false, status: r.status, j })))
        .then((res) => {
          if (res.ok) { this.showSuccess(); return; }
          const f = res.status === 400 && res.j.code === 'validation_error' && res.j.error ? this.f[map[res.j.field]] : null;
          if (f) {
            this.setLoading(false);
            this.setSubmitLabel(this.dataset.labelSubmit);
            this.setError(f, res.j.error);
            this.dataset.stage = 'invalid';
            this.focusFirst();
            return;
          }
          throw new Error('http ' + res.status);
        })
        .catch(fail);
    }

    showSuccess() {
      this.setLoading(false);
      this.form.hidden = true;
      Array.from(this.children).forEach((n) => { if (n.classList && n.classList.contains('rv-done')) n.remove(); });
      this.appendChild(this.tpl('success'));
      this.dataset.stage = 'success';
    }
  }
  customElements.define('lystia-review-form', LystiaReviewForm);

  /* ?state=rv-* : відкрити оверлей і виставити стан */
  const m = /^rv-(form|invalid|error|success)$/.exec(new URLSearchParams(window.location.search).get('state') || '');
  if (m) {
    const go = () => {
      const ov = document.lystiaOverlay;
      if (!ov || !ov.has(OVERLAY)) return;
      pendingStage = m[1] === 'form' ? '' : m[1];
      ov.open(OVERLAY);
    };
    if (document.readyState === 'complete') setTimeout(go, 0);
    else window.addEventListener('load', () => setTimeout(go, 0), { once: true });
  }
}
